import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import columnData from "../../assets/admin/columnData.json";

import {
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import validate from "validate.js";

const EditAccountDialog = (props) => {
  const { open, close, data, updateProfile } = props;

  const [updatedPerson, setUpdatedPerson] = useState("");

  //load data once component mounts
  useEffect(() => {
    setUpdatedPerson(data);
  }, []);

  const handleChange = (event) => {
    setUpdatedPerson({
      ...updatedPerson,
      [event.target.id]: event.target.value,
    });
  };
  const [isValid, setIsValid] = useState({ email: "", phone: "" });
  const validateForm = () => {
    const validEmail = validate.single(updatedPerson.email, {
      presence: true,
      email: true,
    });
    const validPhone =
      updatedPerson.phone === "" || updatedPerson.phone.length >= 10; //empty or greater than 10

    if (validEmail === undefined && validPhone) {
      updateProfile(updatedPerson);
    } else {
      setIsValid({
        email: validEmail,
        phone: validPhone ? "" : "Must be 10 digits or more",
      });
    }
  };
  let form = columnData.columns.filter((column) => column.userEdit);
  form.sort((a, b) => a.editOrder - b.editOrder);

  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>Edit Account</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {form.map((field, index) => (
            <Grid xs={6} key={`${field.id} + ${index}`}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  margin: "8px 12px",
                }}
              >
                <span style={{ fontFamily: "sans-serif" }}>{field.label}</span>
                <TextField
                  id={field.id}
                  value={updatedPerson[field.id]}
                  onChange={handleChange}
                  helperText={isValid[field.id]}
                  error={isValid[field.id]}
                />
              </div>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Cancel</Button>
        <Button
          style={{ margin: 8 }}
          variant="contained"
          onClick={validateForm}
        >
          Update Account
        </Button>
      </DialogActions>
    </Dialog>
  );
};
EditAccountDialog.propTypes = {
  data: PropTypes.object.isRequired,
  open: PropTypes.bool,
  close: PropTypes.func.isRequired,
  updateProfile: PropTypes.func.isRequired,
};
export default EditAccountDialog;
